var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-icon",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    width: 26,
    height: 26,
    transform: "translate(-3 -3)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M10.762,4.742A11.181,11.181,0,0,0,.176,15.859V20l1.481-3.449a10.788,10.788,0,0,1,9.1-5.95V15.34l9.4-7.684L10.762,0Z",
    transform: "translate(-0.176 0)",
    fill: "#3398cb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.cbd3770ddbf33a9db449c453035683fc.svg";
export { ForwardRef as ReactComponent };